export const RESET = 'EXCMCARUSERDATA_LIST_RESET'
export const SET_ITEMS = 'EXCMCARUSERDATA_LIST_SET_ITEMS'
export const SET_ERROR = 'EXCMCARUSERDATA_LIST_SET_ERROR'
export const SET_VIEW = 'EXCMCARUSERDATA_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXCMCARUSERDATA_LIST_TOGGLE_LOADING'
